import { LegalLayout } from "./LegalLayout";
import { CONTACT_BLOCK, LegalSection } from "./shared";

const { H2, P, UL } = LegalSection;

export default function Termos() {
  return (
    <LegalLayout title="Termos e Condições" updated="agosto de 2026">
      <H2>1. Objeto</H2>
      <P>
        Os presentes Termos e Condições regulam a utilização do website da TopEstofos e a
        solicitação de orçamentos para os serviços de higienização de estofos prestados ao
        domicílio em Lisboa e região, incluindo sofás, colchões, poltronas, cadeiras, carpetes,
        cabeceiras e estofos automóveis.
      </P>

      <H2>2. Utilização do website</H2>
      <UL>
        <li>O website tem caráter informativo e destina-se a apresentar os serviços da TopEstofos e
          a permitir o pedido de orçamentos;</li>
        <li>O utilizador compromete-se a utilizar o website de forma lícita, não devendo introduzir
          conteúdos falsos, ofensivos ou que violem direitos de terceiros;</li>
        <li>A TopEstofos reserva-se o direito de atualizar ou suspender conteúdos do website a
          qualquer momento, sem aviso prévio.</li>
      </UL>

      <H2>3. Pedidos de orçamento</H2>
      <UL>
        <li>Os pedidos de orçamento efetuados através do formulário, do WhatsApp ou do e-mail são
          gratuitos e não vinculativos, tanto para o cliente como para a TopEstofos;</li>
        <li>Os preços apresentados no website são valores de referência. O orçamento final pode
          variar de acordo com o tamanho, o estado e as características específicas de cada
          serviço, sendo sempre comunicado ao cliente antes da prestação do serviço;</li>
        <li>A prestação de qualquer serviço fica sujeita a agendamento e confirmação entre as
          partes.</li>
      </UL>

      <H2>4. Prestação de serviços</H2>
      <UL>
        <li>Os serviços são prestados ao domicílio do cliente, em Lisboa e região, no dia e horário
          acordados;</li>
        <li>O cliente deve garantir o acesso ao local e às condições razoáveis de trabalho (por
          exemplo, acesso a energia elétrica e água, quando necessário);</li>
        <li>O tempo médio de secagem indicado (entre 10 e 12 horas) é uma estimativa e pode variar
          consoante o tecido, a temperatura e a ventilação do espaço.</li>
      </UL>

      <H2>5. Responsabilidade</H2>
      <UL>
        <li>A TopEstofos executa os serviços com o cuidado e a diligência devidos, utilizando
          produtos e equipamentos adequados a cada tipo de estofo;</li>
        <li>A TopEstofos não pode ser responsabilizada por danos resultantes de informações
          incorretas ou omissas fornecidas pelo cliente sobre os materiais a higienizar, nem pelo
          agravamento de desgaste, manchas ou danos pré-existentes;</li>
        <li>Nada nos presentes termos exclui ou limita a responsabilidade que não possa ser
          excluída ou limitada nos termos da lei portuguesa.</li>
      </UL>

      <H2>6. Propriedade intelectual</H2>
      <P>
        Todos os conteúdos do website (textos, logótipo, imagens e design) são propriedade da
        TopEstofos ou utilizados com autorização, não podendo ser reproduzidos sem consentimento
        prévio.
      </P>

      <H2>7. Proteção de dados e cookies</H2>
      <P>
        O tratamento de dados pessoais e a utilização de cookies estão regulados pela nossa
        Política de Privacidade e pela nossa Política de Cookies, disponíveis neste website.
      </P>

      <H2>8. Lei aplicável</H2>
      <P>
        Os presentes Termos e Condições regem-se pela lei portuguesa. Para a resolução de litígios
        é competente o foro da comarca de Lisboa, sem prejuízo das normas legais imperativas
        aplicáveis aos consumidores.
      </P>

      {CONTACT_BLOCK}
    </LegalLayout>
  );
}
